import getObjectKey from 'lib/object/getObjectKey'

interface PropertyCalendarPricesKeyParams {
  propertyId: string | undefined
  duration: number | undefined
  occupancies: Array<App.Occupants>
}

function buildPropertyCalendarPricesKey({
  propertyId,
  duration,
  occupancies,
}: PropertyCalendarPricesKeyParams): string {
  if (!(propertyId && duration && occupancies.length)) {
    return ''
  }
  return getObjectKey({
    propertyId,
    duration,
    rooms: occupancies,
  })
}

export default buildPropertyCalendarPricesKey
